// packages/shared-components/src/components/Modal/modal-render.tsx
import React from "react";
import { createRoot } from "react-dom/client";
import { getSubAppPortalContainer } from "@eweadn-qiankun/shared-utils";
import { ModalFunc } from "./Modal";

export interface ModalFuncProps {
  title?: React.ReactNode;
  content?: React.ReactNode | string;
  okText?: string;
  cancelText?: string;
  onOk?: () => void;
  onCancel?: () => void;
  onClose?: () => void;
  width?: number;
  className?: string;
  closable?: boolean;
  footer?: boolean;
}

let modalContainer: HTMLDivElement | null = null;
let root: ReturnType<typeof createRoot> | null = null;

export function renderModal(props: ModalFuncProps) {
  destroyModal();

  modalContainer = document.createElement("div");
  modalContainer.style.position = "fixed";
  modalContainer.style.inset = "0";
  modalContainer.style.width = "0";
  modalContainer.style.height = "0";
  modalContainer.style.flex = "none";
  getSubAppPortalContainer().appendChild(modalContainer);
  root = createRoot(modalContainer);

  const handleClose = () => {
    props.onClose?.();
    destroyModal();
  };

  root.render(
    <ModalFunc
      visible
      title={props.title}
      okText={props.okText}
      cancelText={props.cancelText}
      width={props.width}
      className={props.className}
      closable={props.closable}
      footer={props.footer}
      onOk={() => {
        props.onOk?.();
        destroyModal();
      }}
      onCancel={() => {
        props.onCancel?.();
        destroyModal();
      }}
      onClose={handleClose}
    >
      {props.content}
    </ModalFunc>
  );
}

export function destroyModal() {
  if (root) {
    root.unmount();
    root = null;
  }
  if (modalContainer && modalContainer.parentNode) {
    modalContainer.parentNode.removeChild(modalContainer);
    modalContainer = null;
  }
}
